import { createAction, props } from '@ngrx/store';
import { Customer } from '../models/customer.model';
import { FedexAvrMap } from '../models/fedex-avr.model';

// Load Customers
export const loadCustomers = createAction('[Spots->Customers] Load Customers', props<{ organizationId: string }>());
export const loadCustomersSuccess = createAction('[Spots->Customers] Load Customers Success', props<{ customers: Customer[] }>());

// Add Customer
export const addCustomer = createAction('[Spots->Customers] Add Customer', props<{ organizationId: string, customer: Customer }>());
export const addCustomerSuccess = createAction('[Spots->Customers] Add Customer Success', props<{ customer: Customer }>());

// Update Customer
export const updateCustomer = createAction('[Spots->Customers] Update Customer', props<{ organizationId: string, customerId: number, customer: Partial<Customer> }>());
export const updateCustomerSuccess = createAction('[Spots->Customers] Update Customer Success', props<{ customer: Customer }>());

// Delete Customer
export const deleteCustomer = createAction('[Spots->Customers] Delete Customer', props<{ organizationId: string, customerId: number }>());
export const deleteCustomerSuccess = createAction('[Spots->Customers] Delete Customer Success', props<{ customerId: number }>());

// FedEx AVR Actions (now part of customer management)
export const updateFedexAvr = createAction(
  '[Customer] Update FedEx AVR',
  props<{ organizationId: string; key: string; fedexAvr: any }>()
);

export const updateFedexAvrSuccess = createAction(
  '[Customer] Update FedEx AVR Success',
  props<{ fedexAvr: any; key: string }>()
);

export const updateFedexAvrFailure = createAction(
  '[Customer] Update FedEx AVR Failure',
  props<{ error: any }>()
);
